"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormElementTypeExposedEnum = void 0;
var FormElementTypeExposedEnum;
(function (FormElementTypeExposedEnum) {
    FormElementTypeExposedEnum["INPUT"] = "input";
    FormElementTypeExposedEnum["TEXT"] = "text";
    FormElementTypeExposedEnum["HTML"] = "html";
    FormElementTypeExposedEnum["NUMBER"] = "number";
    FormElementTypeExposedEnum["SELECT"] = "select";
    FormElementTypeExposedEnum["LIST"] = "list";
    FormElementTypeExposedEnum["SWITCH"] = "switch";
    FormElementTypeExposedEnum["RADIO"] = "radio";
    FormElementTypeExposedEnum["CHECKBOXES"] = "checkboxes";
    FormElementTypeExposedEnum["CHECKBOX"] = "checkbox";
    FormElementTypeExposedEnum["EMAIL"] = "email";
    FormElementTypeExposedEnum["PHONE"] = "phone";
    FormElementTypeExposedEnum["FILE"] = "file";
})(FormElementTypeExposedEnum = exports.FormElementTypeExposedEnum || (exports.FormElementTypeExposedEnum = {}));
